
<template>
  <div id="idlePublish-after">
    <div class="lv0Text t">
      <i class="far fa-check-circle fa-2x" style="margin-right:20px"></i>
      <span>闲置已发布，等待审核中</span>
      <div class="lv2Text back">
        <router-link to="/user/idle">查看闲置交换</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "闲置交换";
    this.$store.state.user_location2 = "发布闲置";
    this.$store.state.leftMenuIndex = 14;
  },

  methods: {
    //
  }
};
</script>
<style lang="scss">
#idlePublish-after {
  .t {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding: 60px 0;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .fa-check-circle {
    position: relative;
    top: 10px;
  }
  .back {
    font-size: 14px;
    font-weight: normal;
    margin-top: 40px;
    a:hover {
      color: #e2211c;
      text-decoration: underline;
    }
  }
}
</style>